import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
export interface QueryParams {
  /** 开始时间，秒级时间戳（页面侧 useParseTime） */
  start_time?: number | string
  /** 结束时间，秒级时间戳（页面侧 useParseTime） */
  end_time?: number | string
}

export interface ResponseData {
  /** 终端总数 */
  terminal_count: number
  /** 上周终端总数 */
  last_week_terminal_count: number
  /** windows终端数 */
  windows_terminal_count: number
  /** macos 终端数 */
  macos_terminal_count: number
  /** server 终端数 */
  server_terminal_count: number
  /** linux 终端数 */
  linux_terminal_count: number
  /** 发生变更硬件 */
  change_terminal_count: number
  /** linux 终端数 */
  last_week_change_terminal_count: number
  /** usb接入次数统计 */
  usb_terminal_count: number
  /** 上周usb接入次数 */
  last_week_usb_terminal_count: number
}

@Injectable()
export class AssetStatusService {
  constructor (private http: Http) {
  }


  getAssetStatus (data: QueryParams) {
    return this.http.post<ResponseData>('/homepage/asset-status', data)
  }
}
